module.exports = __webpack_public_path__ + "img/ic_feedback.c41033f0.png";